export default __webpack_public_path__ + "static/media/maple.b24e653d.webp";